<template>
  <div class="page_content_container pg_frm_popup widget_v2_1">

    <div class="row head">
      <div class="col-4 logo_container">
        <img class="logo" src="../../../assets/theme/default/img/pragyaLogo.svg" alt="Pragya Systems Logo">
      </div>
      <div class="col-4">
        <div class="head_txt">The Pragya Widget</div>
      </div>
      <div class="col-4"></div>
    </div>

    <div class="row">
      <div class="col-1"></div>
      <div class="col-10">

        <div class="row msg_sec" style="margin-bottom: 0px;">
          <div class="col-12 hd_txt">
            Welcome!
          </div>
          <div class="col-12 msg_txt">
            <p>
              We are in the process of approving your institution for the Pragya Website Widget.
              Once approved you will be able to download or copy/paste the widget code and embed it
              in your website. You can finish setting up the account and get familiar with the widget
              by playing around with an existing widget.
            </p>
            <p>
              Please select a strong password for your account.
            </p>
          </div>
        </div>

      </div>
    </div>

    <div class="row">
      <div class="col-xl-2"></div>
      <div class="col-xl-6 col-lg-8 col-md-10 col-sm-12 login-user-section login_sec_box content_bx" @keydown.enter="login">

        <div class="modal-header">
          <div class="head_txt">Setup your acccount</div>
        </div>

        <div class="modal-body">


          <div class="row page_fld_section">
              <div class="col-12">
                  <div class="fld-label" id="password">New Password <sup>*</sup></div>
              </div>
              <div class="col-12">
                    <b-form-input type="password" v-model.trim="password" placeholder="Password (Must be at least 5 characters long)" style="height: 1.5em !important;">
                    </b-form-input>
              </div>
          </div>

          <div class="row page_fld_section">
              <div class="col-12">
                  <div class="fld-label" id="password">Confirm Password <sup>*</sup></div>
              </div>
              <div class="col-12">
                    <b-form-input type="password" v-model.trim="repassword" placeholder="Re-Type Password" style="height: 1.5em !important;">
                    </b-form-input>
              </div>
          </div>
          <div class="row page_fld_section  fld_terms">
            <div class="col-12">
              <input type="checkbox" id="tnc_chkbox" v-model="status">
              <label for="tnc_chkbox"> I agree to the pragya systems
                <b-link href="javascript://" @click="showTermsOfUse">terms of use</b-link> and
                <b-link href="javascript://" @click="showPrivacyPolicy">Privacy Policy</b-link>.</label>
            </div>
          </div>

          <div class="row page_fld_section">
            <div class="col-12 btn_container">
              <b-button size="lg" @click="verifyUser" aria-label="verify">Finish Setup</b-button>
            </div>
          </div>

        </div> <!-- .modal-body -->

      </div>
      <div class="col-xl-2"></div>
    </div>

    <div class="pg_frm_popup">
      <b-modal class="" ref="privacyPolicyModal" title="Privacy Policy" hide-footer centered>
        <privacy-policy></privacy-policy>
      </b-modal>

      <b-modal class="" ref="termsOfUseModal" title="Terms of Use" hide-footer centered>
        <terms-of-use></terms-of-use>
      </b-modal>
    </div>

    <div class="loading-spinner">
        <b-modal style="padding: 0px;" ref="loadingModal" ok-disabled cancel-diasbled hide-header hide-footer no-close-on-backdrop no-close-on-esc size="sm" centered>
            <div class="text-center" style="color: #FFF">
                <i class="fa fa-spinner fa-3x fa-fw fa-pulse"></i>
            </div>
        </b-modal>
    </div>

  </div>
</template>

<script>
  // import Vue from 'vue'
  import { mapActions, mapState } from 'vuex'
  import PrivacyPolicy from '../../user/components/PrivacyPolicy'
  import TermsOfUse from '../../user/components/TermsOfUse'
  export default {
    name: 'widget-admin-verify',
    components: {
      PrivacyPolicy,
      TermsOfUse
    },
    data: () => {
      return {
        eMail: '',
        password: '',
        verificationCode: '',
        repassword: '',
        status: false
      }
    },
    watch: {
    },
    computed: {
      ...mapState({
      })
    },
    mounted () {
      this.loadVerificationPage()
    },
    methods: {
      ...mapActions([
        'loadLoginUser',
        'loadVerifyUser',
        'setUserInfo',
        'loadLogDashboardActivity'
      ]),
      getQueryParamByName(name, url = window.location.href) {
        name = name.replace(/[\[\]]/g, '\\$&')
        let regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)')
        let results = regex.exec(decodeURIComponent(url))
        if (!results || !results[2]) return ''
        return results[2].replace(/\+/g, ' ')
      },
      loadVerificationPage () {
        this.eMail = this.getQueryParamByName('email')
        this.verificationCode = this.getQueryParamByName('verificationCode')
      },
      async verifyUser () {
        let userObj = {
          'eMail': this.eMail,
          'password': this.password,
          'verificationCode': this.verificationCode
        }
        if (this.eMail.length < 1) {
          this.notifyFailure('Oops! Email is missing. Please try again by going back to the widget')
        } else if (this.password.length < 5) {
          this.notifyFailure('Password cannot be fewer than 5 characters!')
        } else if (this.verificationCode.length < 5) {
          this.notifyFailure('Verificaton Code cannot be fewer than 5 characters!')
        } else if (this.password !== this.repassword) {
          this.notifyFailure('Passwords do not match! Please try again.')
        } else if (!this.status) {
          this.notifyFailure('Please agree to Terms of Use and Privacy Policy to continue')
        } else {
          this.showLoader()
          let response = await this.loadVerifyUser(userObj)
          let status = response.status
          let data = response.data
          if (status === 200) {
            this.setUserInfo(data)
            // navigate To explore based on major\
            this.$parent.isUserLoggedIn = true
            this.$parent.isServiceAvailable = true
            this.$parent.isWidgetAdminVerification = false
            let role = localStorage.getItem('userrole')
            role = role.toLowerCase()
            let url = '/user/track/' + role.split(' ').join('_')
            return this.$router.push(url)
          } else {
            this.notifyFailure('Error: Verificaton Code did not match!')
          }
          this.hideLoader()
        }
      },
      showPrivacyPolicy () {
        if (this.$refs.privacyPolicyModal) {
          this.$refs.privacyPolicyModal.show()
        }
      },
      showTermsOfUse () {
        if (this.$refs.termsOfUseModal) {
          this.$refs.termsOfUseModal.show()
        }
      },
      showLoader () {
        if (this.$refs.loadingModal) {
          this.$refs.loadingModal.show()
        }
      },
      hideLoader () {
        if (this.$refs.loadingModal) {
          this.$refs.loadingModal.hide()
        }
      },
      notifyFailure (text) {
        this.$notify({
          group: 'notify',
          type: 'error',
          title: '',
          text: text
        })
      }
    }
  }
</script>

<style scoped>
.color-white a {
  color: #ffffff;
}
.close_button {
  margin-top: 10px;
}
.page_fld_section {
  margin-left: 4rem;
}
.verification_pg .login_sec_box {
  max-height: 450px;
}
input[type="checkbox"] {
  -moz-transform: scale(1);
  margin-right: 7px;
  margin-top: 5px;
  float: left;
}
.modal .top-title {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/app/login/components/WidgetAdminVerify.vue